import { Layer } from "@luciad/ria/view/Layer";
import { RasterTileSetLayer } from "@luciad/ria/view/tileset/RasterTileSetLayer";
import { OGCAPIMapsCapabilitiesLayer } from "./OGCAPIMapsCapabilitiesLayer";
import { OGCAPIMapsModel } from "./OGCAPIMapsModel";

export const OGCAPIMapsDataLoader = {

  createLayer: (capabilitiesLayer: OGCAPIMapsCapabilitiesLayer): Layer => {

    // if (capabilitiesLayer.useVectorTiles) {
    //   const model = new OGCAPITilesFeatureModel(capabilitiesLayer.url, capabilitiesLayer.bounds);

    //   // return new OGCAPITilesFeatureLayer(model, {
    //   //   id: capabilitiesLayer.name,
    //   //   label: capabilitiesLayer.title
    //   // });

    // }
    // else {
    const model = new OGCAPIMapsModel({
      baseURL: capabilitiesLayer.url,
      bounds: capabilitiesLayer.bounds,
      reference: capabilitiesLayer.bounds.reference!
    });

    model._bboxCrs = capabilitiesLayer.bboxCrs;

    const layer = new RasterTileSetLayer(model, {
      id: capabilitiesLayer.name,
      label: capabilitiesLayer.title
    });

    return layer;
    // };
  }
};
